// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var TextField = require("@mui/material/TextField").default;
var Pagination = require("@mui/material/Pagination").default;

var nonDigitPattern = /\D/g;

function propsAreSame(a, b) {
  if (a.settingsVer === b.settingsVer && a.preCtxVer === b.preCtxVer) {
    return a.labelsVer === b.labelsVer;
  } else {
    return false;
  }
}

var make = React.memo((function (param) {
        var labels = param.labels;
        var match = React.useState(function () {
              return 0;
            });
        var setPageIdx = match[1];
        var pageIdx = match[0];
        var match$1 = React.useState(function () {
              return "";
            });
        var setGoToPageText = match$1[1];
        var goToPageText = match$1[0];
        var numOfPages = Math.ceil(labels.length / 20) | 0;
        var beginIdx = Math.imul(pageIdx, 20);
        var endIdx = (beginIdx + 20 | 0) - 1 | 0;
        React.useEffect((function () {
                Curry._1(setPageIdx, (function (param) {
                        return 0;
                      }));
                Curry._1(setGoToPageText, (function (param) {
                        return "";
                      }));
              }), [param.labelsVer]);
        var actChangePage = function (newPageNum) {
          if (1 <= newPageNum && newPageNum <= numOfPages) {
            Curry._1(setPageIdx, (function (param) {
                    return newPageNum - 1 | 0;
                  }));
            return Curry._1(setGoToPageText, (function (param) {
                          return "";
                        }));
          }
          
        };
        var actGoToPage = function (param) {
          var newPageNum = Belt_Int.fromString(goToPageText);
          if (newPageNum !== undefined) {
            return actChangePage(newPageNum);
          }
          
        };
        var rndPagination = function (param) {
          var partial_arg = actGoToPage;
          return React.createElement(Expln_React_Row.make, {
                      alignItems: "center",
                      children: Caml_option.some(null)
                    }, React.createElement(Pagination, {
                          count: numOfPages,
                          page: pageIdx + 1 | 0,
                          onChange: (function (param, newPage) {
                              actChangePage(newPage);
                            })
                        }), React.createElement(TextField, {
                          value: goToPageText,
                          label: "Go to page",
                          size: "small",
                          style: {
                            width: "150px"
                          },
                          onChange: (function (param) {
                              return Expln_React_common.evt2str((function (newPage) {
                                            Curry._1(setGoToPageText, (function (param) {
                                                    return newPage.replace(nonDigitPattern, "");
                                                  }));
                                          }), param);
                            }),
                          onKeyDown: (function (param) {
                              return MM_react_common.kbrdHnd(undefined, partial_arg, undefined, undefined, param);
                            })
                        }));
        };
        if (labels.length === 0) {
          return "No assertions loaded.";
        } else {
          return React.createElement(Expln_React_Column.make, {
                      children: Caml_option.some(null)
                    }, rndPagination(undefined), labels.slice(beginIdx, endIdx + 1 | 0).map(function (param) {
                          return "" + String(param[0]) + " - " + param[1] + "";
                        }));
        }
      }), propsAreSame);

var pageSize = 20;

exports.pageSize = pageSize;
exports.nonDigitPattern = nonDigitPattern;
exports.propsAreSame = propsAreSame;
exports.make = make;
/* make Not a pure module */
